export default __webpack_public_path__ + "static/media/plus_dark.de239485.svg";